import { InformationCircleIcon } from "@heroicons/react/20/solid";
import toast from "react-hot-toast";
import { useTranslation } from "react-i18next";
import { Base } from "@/atoms-react/text/Text.react";
import { companyDetails } from "@/features/company/types";
import { useDocument } from "@/features/user/document/hooks/use-document";
import { LegalDocument } from "@/features/user/document/types";
import { UploadDocumentInput } from "@/molecules/upload-document-input";

type CompanyOrganizationalChartProps = {
  companyDetails: companyDetails | null | undefined;
  actionEnabled: boolean;
};

export const CompanyOrganizationalChart = (props: CompanyOrganizationalChartProps) => {
  const { companyDetails } = props;
  const { t } = useTranslation(["pass"]);

  const { UploadDocumentChartMutation } = useDocument();
  const { mutateAsync: uploadDocument, isPending: isUploadPending } = UploadDocumentChartMutation();

  return (
    <div className="mt-8 flex flex-col">
      <Base className="mb-3 px-1 font-semibold text-xl">{t("business_links.organigram")}</Base>
      <div className="flex basis-2/3 flex-col justify-between rounded-sm border-2 border-slate-50 px-4 py-4 md:px-2 md:py-2 lg:flex-row dark:border-slate-700">
        <div className="flex flex-col justify-center">
          <div className="flex flex-row">
            <Base className="px-1 font-semibold text-base">
              {t("business_links.organigram_input")}
            </Base>

            <InformationCircleIcon
              className="ml-4 h-5 w-5 rounded-full bg-primary text-white dark:text-slate-900"
              data-tooltip={t("business_links.organigram_input_tooltip")}
              data-position="right"
            />
          </div>
        </div>

        <UploadDocumentInput
          document={companyDetails?.legalEntity?.OrganizationalDocument ?? null}
          disabled={isUploadPending || !props.actionEnabled}
          onError={(messagekey: string) => {
            toast.error(t(messagekey));
          }}
          onChange={(data: LegalDocument) => {
            if (data.base64docs && data.fileFormat) {
              data.base64docs = `data:${data.fileFormat};base64,${data.base64docs}`;
              uploadDocument(data);
            }
          }}
          className="mt-4 basis-1/3 lg:mt-0"
        />
      </div>
    </div>
  );
};
